import * as React from 'react';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgEvmTestnet = function SvgEvmTestnet(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 122 122"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M121 61c0 33.137-26.863 60-60 60S1 94.137 1 61 27.863 1 61 1s60 26.863 60 60"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M61 1.5C28.14 1.5 1.5 28.14 1.5 61s26.64 59.5 59.5 59.5 59.5-26.64 59.5-59.5S93.86 1.5 61 1.5M.5 61C.5 27.587 27.587.5 61 .5s60.5 27.087 60.5 60.5-27.087 60.5-60.5 60.5S.5 94.413.5 61",
        clipRule: "evenodd"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#B6B6B6",
        d: "m60.836 25-.477 1.621v47.042l.477.476 21.836-12.907z"
    })), _path4 || (_path4 = /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M60.773 24.504a.5.5 0 0 1 .492.238L83.1 60.974a.5.5 0 0 1-.173.688L61.09 74.57a.5.5 0 0 1-.608-.077l-.477-.476a.5.5 0 0 1-.147-.354V26.621a.5.5 0 0 1 .02-.14l.478-1.622a.5.5 0 0 1 .416-.355m.222 1.728-.136.461v46.763l.056.056 21.069-12.454z",
        clipRule: "evenodd"
    })), _path5 || (_path5 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M60.836 25 39 61.232l21.836 12.907V25"
    })), _path6 || (_path6 = /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M60.97 24.518a.5.5 0 0 1 .366.482v49.14a.5.5 0 0 1-.754.43L38.746 61.662a.5.5 0 0 1-.174-.688l21.836-36.232a.5.5 0 0 1 .562-.224M39.69 61.058l20.647 12.205V26.798z",
        clipRule: "evenodd"
    })), _path7 || (_path7 = /*#__PURE__*/ React.createElement("path", {
        fill: "#666",
        d: "m60.836 78.273-.269.329v16.757l.27.785 21.849-30.771z"
    })), _path8 || (_path8 = /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M83.054 65.034a.5.5 0 0 1 .04.628l-21.85 30.771a.5.5 0 0 1-.88-.127l-.27-.785a.5.5 0 0 1-.027-.162V78.602a.5.5 0 0 1 .114-.318l.269-.328a.5.5 0 0 1 .132-.113l21.85-12.9a.5.5 0 0 1 .622.091M61.067 78.78l.1-.121L80.92 66.996 61.067 94.955z",
        clipRule: "evenodd"
    })), _path9 || (_path9 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M60.836 96.144v-17.87L39 65.372z"
    })), _path10 || (_path10 = /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M38.632 65.034a.5.5 0 0 1 .622-.092l21.837 12.901a.5.5 0 0 1 .245.43v17.87a.5.5 0 0 1-.907.29l-21.837-30.77a.5.5 0 0 1 .04-.629m2.133 1.962 19.571 27.58V78.558z",
        clipRule: "evenodd"
    })), _path11 || (_path11 = /*#__PURE__*/ React.createElement("path", {
        fill: "#494949",
        d: "m60.836 74.14 21.836-12.908-21.836-9.926z"
    })), _path12 || (_path12 = /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M60.566 50.886a.5.5 0 0 1 .477-.035l21.836 9.926a.5.5 0 0 1 .047.885L61.092 74.57a.5.5 0 0 1-.755-.43V51.305a.5.5 0 0 1 .23-.42m.77 1.197v21.18L81.591 61.29z",
        clipRule: "evenodd"
    })), _path13 || (_path13 = /*#__PURE__*/ React.createElement("path", {
        fill: "#828282",
        d: "m39 61.232 21.836 12.907V51.306z"
    })), _path14 || (_path14 = /*#__PURE__*/ React.createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M61.107 50.886a.5.5 0 0 1 .23.42V74.14a.5.5 0 0 1-.755.43L38.746 61.663a.5.5 0 0 1 .047-.885L60.63 50.85a.5.5 0 0 1 .477.035M40.081 61.29l20.255 11.973v-21.18z",
        clipRule: "evenodd"
    })));
};

export { SvgEvmTestnet as ReactComponent };
//# sourceMappingURL=EVMTestnet.svg.es.js.map
